import { connect } from 'react-redux'
import Flows from './Flows'
import { push } from 'react-router-redux'
import { getFlows, confirmDeleteFlow } from 'features/Flows/Flows.actions'
import showFlowCreateModal from 'features/Flows/FlowCreateModal'

const stateToProps = ({ flows }) => ({
  flows,
})

const dispatchToProps = {
  getFlows,
  showFlowCreateModal,
  confirmDeleteFlow,
  push,
}

export default connect(stateToProps, dispatchToProps)(Flows)



// WEBPACK FOOTER //
// ./src/pages/Flows/Flows.container.js